import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainPage from "./pages/main-page";

function App() {
  return (
          <MainPage />
  );
}

export default App;
